module.exports = __webpack_public_path__ + "static/media/CARS.26a8d8a0.jpg";